import { Card, Text } from "@clipboard-health/ui-components";
import { CardActionArea, CardContent, Stack } from "@mui/material";

import { Button } from "../components/Button";
import { IconButton } from "../components/IconButton";

interface CbhWrappedBannerProps {
  source: "home-screen" | "account-page";
  onClick: () => void;
  onClose?: () => void;
}

// Exact gradient from Figma: radial-gradient(143.47% 257.35% at 29.58% 35.09%, #FF7F8C 0%, #FFA8BA 45.67%, #FFD7F0 97.12%), #FFFFFF
const BACKGROUND_GRADIENT =
  "radial-gradient(143.47% 257.35% at 29.58% 35.09%, #FF7F8C 0%, #FFA8BA 45.67%, #FFD7F0 97.12%), #FFFFFF";

export function CbhWrappedBanner(props: CbhWrappedBannerProps) {
  const { onClick, source, onClose } = props;
  const isAccountPage = source === "account-page";
  const isHomeScreen = source === "home-screen";

  const handleClose = (event: React.MouseEvent) => {
    event.stopPropagation();
    onClose?.();
  };

  return (
    <Card sx={{ background: BACKGROUND_GRADIENT, position: "relative" }}>
      {isHomeScreen && onClose && (
        <IconButton
          aria-label="Close banner"
          iconType="close"
          size="medium"
          variant="ghost"
          sx={(theme) => ({
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 1,
            color: theme.palette.text.invertPrimary,
          })}
          onClick={handleClose}
        />
      )}
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Stack
            direction="column"
            alignItems="flex-start"
            spacing={3}
            sx={{ paddingY: isAccountPage ? 2 : 0 }}
          >
            {source === "home-screen" && (
              <Text semibold variant="h2">
                🎉
              </Text>
            )}
            <Text
              variant={isAccountPage ? "h6" : "h4"}
              sx={(theme) => ({
                textWrap: "balance",
                color: theme.palette.text.invertPrimary,
                fontWeight: 600,
              })}
            >
              Your 2025 Recap Is Here!
            </Text>

            <Stack direction="column" spacing={5}>
              <Text
                semibold
                variant={isAccountPage ? "body2" : "body1"}
                sx={(theme) => ({ color: theme.palette.text.invertPrimary })}
              >
                Thanks for being a valued part of the Clipboard community! Let&apos;s see what you
                accomplished this year.
              </Text>

              <Button fullWidth variant="outlined" size={isAccountPage ? "small" : "medium"}>
                Show me my year!
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
